// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from './environement.intarface';
const url = window.location.href;
const formatUrl = new URL(url);
export const env = formatUrl.origin.includes('dev.')
  ? '.dev'
  : formatUrl.origin.includes('valid.')
    ? '.valid'
    : '';
export const environment: Environment = {
  api: env
    ? `https://diagnostique.kccyberdefense${env}.tic-nova.com/api`
    : `https://api.kccybersecurity.com/api`,
  host: env ? `https://kccyberdefense${env}.tic-nova.com` : `https://kccybersecurity.com`,
  // Production : meme cle que le site public (kccybersecurity.com), la seule
  // dont l'API detient le secret. Le domaine app.kccybersecurity.com doit
  // figurer dans les domaines de cette cle (console Google reCAPTCHA).
  siteKey: env
    ? '6LeamrAqAAAAAEqfXlKOVONemxXT9rJJSdFnOZ-u'
    : '6Ledv2QtAAAAAIFPkZ2ET4_siBFKbrUlssAk4nwv',
  // prettier-ignore
  version: 'RELEASE-APP-VERSION-CI',
  code: 'kcd',
  disableIndexing: env ? true : false,
  env: env === '.dev' ? 'DEV' : env === '.valid' ? 'VALID' : 'PROD',
};
